import { render, staticRenderFns } from "./SkillEdit.vue?vue&type=template&id=a4c1bbf2&"
import script from "./SkillEdit.vue?vue&type=script&lang=js&"
export * from "./SkillEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports